import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/icons/homeV2.svg'
import _imports_1 from '../../public/icons/header/cloud_new.svg'
import _imports_2 from '../../public/icons/header/color-fill.svg'
import _imports_3 from '../../public/icons/dialog/whatsnew_notification.svg'
import _imports_4 from '../../public/icons/dialog/re_whatsnew.svg'


const _hoisted_1 = {
  key: 0,
  class: "curtain"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "headerbtnmain" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "tenant-name" }
const _hoisted_6 = { class: "tenantmodal" }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  src: _imports_3
}
const _hoisted_11 = {
  key: 1,
  src: _imports_4
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudIcon = _resolveComponent("CloudIcon")!
  const _component_f_icon_button = _resolveComponent("f-icon-button")!
  const _component_TenantColorPickerContextMenu = _resolveComponent("TenantColorPickerContextMenu")!
  const _component_f_menu = _resolveComponent("f-menu")!
  const _component_f_dropdown = _resolveComponent("f-dropdown")!
  const _component_WhatsNewDialog = _resolveComponent("WhatsNewDialog")!

  return (_openBlock(), _createElementBlock("div", {
    id: "breadcrumb",
    ref: "breadcrumbRoot",
    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeTenantDropdown($event)))
  }, [
    _createVNode(_Transition, { name: "curtain" }, {
      default: _withCtx(() => [
        (_ctx.TenantDropDownVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      src: _imports_0,
      class: "breadcrumb-homeV2-svg",
      style: {"cursor":"pointer"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
    }),
    _createVNode(_TransitionGroup, {
      name: "fso",
      tag: "span"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BreadCrumbItems, (item, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("span", {
            key: item.payload.id,
            style: _normalizeStyle({'--i':i})
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("img", { class: "arrowLeft breadcrumb-svg" }, null, -1)),
            _createElementVNode("span", {
              class: "breadcrumb-button",
              onClick: ($event: any) => (_ctx.BreadcrumbItem_Click(item))
            }, _toDisplayString(_ctx.getTranslation(item.name)), 9, _hoisted_2)
          ], 4)), [
            [_vShow, _ctx.getTranslation(item.name)]
          ])
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.Tenant!=null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "tenant_v2",
          ref: "tenantContainerV2",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleTenantDropDown()), ["stop"])),
          class: "no-outline",
          tabindex: "1"
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tenant-divider" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "tenant-section",
              title: _ctx.Tenant.name ?? '',
              style: _normalizeStyle({ 
                '--line-color': _ctx.getTenantIconColor() !== _ctx.DefaultTenantColor ? _ctx.getTenantIconColor() : 'transparent' })
            }, [
              _createVNode(_component_CloudIcon, {
                class: "cloud-icon",
                color: _ctx.getTenantIconColor()
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(""+_ctx.FormatTenantName(_ctx.Tenant.name, _ctx.Tenant.caption)), 1),
              _cache[11] || (_cache[11] = _createTextVNode("   ", -1)),
              _createVNode(_component_f_icon_button, {
                icon: "chevrondown",
                class: "theme-svg"
              })
            ], 12, _hoisted_4)
          ]),
          _createVNode(_Transition, { name: "headermodal" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "headerbtn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchTenant && _ctx.switchTenant(...args)))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                    src: _imports_1,
                    style: {"margin-right":"8px"}
                  }, null, -1)),
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("Header_Switch_Tenant")), 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "dividing-line" }, null, -1)),
                _createElementVNode("div", {
                  class: "headerbtn",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openColorPickerMenu($event)), ["stop"]))
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                    src: _imports_2,
                    style: {"margin-right":"8px"}
                  }, null, -1)),
                  _createTextVNode("  " + _toDisplayString(_ctx.Localizer.Localize("Header_Change_Color")), 1)
                ])
              ], 512), [
                [_vShow, _ctx.TenantDropDownVisible]
              ])
            ]),
            _: 1
          }),
          (_ctx.showColorPickerMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(_ctx.colorPickerMenuStyle)
              }, [
                _createVNode(_component_TenantColorPickerContextMenu, {
                  "current-color": _ctx.getTenantIconColor(),
                  onColorSelected: _ctx.onColorSelected,
                  onResetColor: _ctx.onResetColor,
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showColorPickerMenu = false))
                }, null, 8, ["current-color", "onColorSelected", "onResetColor"])
              ], 4))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (this.Tenant)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "languages",
          title: this.getLanguageTitleText()
        }, [
          _createElementVNode("input", {
            type: "file",
            id: "loadLanguageFile",
            style: {"display":"none"},
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.LoadCustomLanguage && _ctx.LoadCustomLanguage(...args))),
            accept: "text/json"
          }, null, 32),
          _createVNode(_component_f_dropdown, {
            trigger: ['click'],
            class: "no-outline"
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_f_menu, {
                items: _ctx.localeLangs(),
                onClick: _ctx.setOverrideLang,
                value: _ctx.selLang,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selLang) = $event)),
                class: "anaplanCustom"
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("div", {
                    title: _ctx.Localizer.Localize(item.name.length == 2 ? 'lng_' + item.name.toUpperCase() : '')
                  }, [
                    _createTextVNode(_toDisplayString(item.caption) + " ", 1),
                    (item.name.length == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(item.name.toUpperCase()) + ")", 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_8)
                ]),
                _: 1
              }, 8, ["items", "onClick", "value"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_f_icon_button, {
                icon: "translation",
                color: "#242D48 "
              })
            ]),
            _: 1
          })
        ], 8, _hoisted_7))
      : _createCommentVNode("", true),
    (!_ctx.hideWhatsNew)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "whatsnew",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OpenReleaseNotes()))
        }, [
          (_ctx.newVersionUpdatesAvailable)
            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
            : (_openBlock(), _createElementBlock("img", _hoisted_11))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showReleaseNotes==true)
      ? (_openBlock(), _createBlock(_component_WhatsNewDialog, {
          key: 3,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showReleaseNotes=false)),
          ishtml: true,
          size: 'lg'
        }))
      : _createCommentVNode("", true)
  ], 512))
}